/**
 * Copy for the sign-in page. Centralized for easy updates and potential i18n.
 */
export const LOGIN_COPY = {
  headlineLine1: 'Staff time and attendance',
  headlineLine2: 'in one place',
  subhead:
    'For HR, managers, and staff — track time, leave, shifts, and payroll from a single portal.',
  trustLine: 'Multi-tenant • Role-based access • Your data, your organization',
  signInPrompt: 'Sign in to your account',
  welcomeBack: 'Welcome back',
  signInToContinue: 'Sign in to continue',
} as const

export const LOGIN_FEATURES = [
  {
    label: 'Clock in/out and shift management',
    description: 'Track hours and manage shifts in one place.',
    icon: 'Clock',
  },
  {
    label: 'Leave requests and approvals',
    description: 'Request leave and get approvals from your team.',
    icon: 'CalendarCheck',
  },
  {
    label: 'Payroll and documents',
    description: 'View payslips and manage documents securely.',
    icon: 'FileText',
  },
  {
    label: 'Audit trail and permissions',
    description: 'Role-based access with full audit history.',
    icon: 'ShieldCheck',
  },
] as const
